import ProductoSedes from "./productoSedes";
import Mensajes from "../../../../../base/components/mensajes";

class Productos extends React.Component {
    constructor() {
        super();
        this.state = {
            productsActiveKey: 0,
            products: [
                {
                    id: 1,
                    option: 1,
                    name: 'Salud Oral',
                    key: 'SaludOral',
                    request: 'ConsultarServiciosAtencion',
                    services: [],
                    type: ['EP'],
                    loaded: false
                },
                {
                    id: 2,
                    option: 2,
                    name: 'Salud Visual',
                    key: 'SaludVisual',
                    request: 'ConsultarServiciosAtencion',
                    services: [],
                    type: ['EP'],
                    loaded: false
                },
                {
                    id: 3,
                    option: 3,
                    name: 'Apoyo Diagnóstico',
                    key: 'ApoyoDiagnostico',
                    request: 'ConsultarServiciosAtencion',
                    services: [],
                    type: ['EP'],
                    loaded: false
                },
                {
                    id: 4,
                    option: 4,
                    name: 'Medicamentos',
                    key: 'Medicamentos',
                    request: 'ConsultarServiciosAtencion',
                    services: [],
                    type: ['EP'],
                    loaded: false
                },
                /*{
                    id: 5,
                    option: 3,
                    nameEP: 'Red de Urgencias Inicial',
                    nameCE: 'Atención Prioritaria',
                    key: 'RedUrgenciasInicial',
                    request: 'ConsultarRedAfiliadoServicios',
                    services: [],
                    type: ['EP', 'CE'],
                    loaded: false
                },*/
  
                {
                    id: 5,
                    option: 3,
                    nameEP: 'Red de Urgencias Inicial',
                    nameCE: 'Atención Prioritaria',
                    key: 'AtencionPrioritaria',
                    request: 'ConsultarRedAfiliadoServicios',
                    services: [],
                    type: ['CE'],
                    loaded: false
                },
                {
                    id: 6,
                    option: 3,
                    nameEP: 'Red de Urgencias Inicial',
                    nameCE: 'Atención Prioritaria',
                    key: 'RedUrgenciasInicial',
                    request: 'ConsultarRedAfiliadoServicios',
                    services: [],
                    type: ['EP'],
                    loaded: false
                },
                {
                    id: 7,
                    option: 4,
                    name: 'Red de Urgencias por Especialidad',
                    key: 'RedUrgenciasEspecialidad',
                    request: 'ConsultarRedAfiliadoServicios',
                    specialities: [
                        {
                            id: 1,
                            option: 853,
                            name: 'Cardiovascular',
                            services: [],
                            loaded: false
                        },
                        {
                            id: 2,
                            option: 864,
                            name: 'Maternidad',
                            services: [],
                            loaded: false
                        }
                    ],
                    services: [],
                    type: ['EP', 'CE']
                }
            ]
        };
        this.updateProductsState = this.updateProductsState.bind(this);
        this.loadLocations = this.loadLocations.bind(this);
        this.loadSpecialityLocations = this.loadSpecialityLocations.bind(this);
        this.pnpService = new ServicioPnp();
        this.capitalizeName = this.capitalizeName.bind(this);
    }
    
    componentDidMount() {
        this.pnpService.getList('parametrosPaginas', (list) => {
            
            const products = JSON.parse(JSON.stringify(this.state.products));
            
            list.forEach((item) => {
              products.map((product, index) => {
                if(item.CSNombreText == 'TipoServicio' + (this.props.plan == 'EP' ? 'PBS' : 'PC') + product.key){
                    product.description = item.CSDescripcionNote;
                }
              })
            });
            this.setState({ products });
        }, (this.props.plan == 'EP' ? "CSFormularioChoice eq 'PBS RA Tipo Otros Servicios '" : "CSFormularioChoice eq 'PC RA Tipo Otros Servicios '"));
    }
  
    updateProductsState(product, productIndex, specialityIndex) {
        const products = JSON.parse(JSON.stringify(this.state.products));
        if (specialityIndex != null) {
            products[productIndex].specialities[specialityIndex] = product;
        } else {
            products[productIndex] = product;
        }
        this.setState({ products });
    }
  
    loadLocations(productsActiveKey) {
        if (productsActiveKey) {
            const products = JSON.parse(JSON.stringify(this.state.products));
            const product = products[productsActiveKey-1];
               if (!product.specialities && product.loaded === false) {
                const getProductLocations = new ServicioProxy(product.request + '?tipoDocumento=' + (this.props.userInfo.TipoIdentificacion) + '&numeroDocumento=' + (this.props.userInfo.LegalID) + '&opcion=' + product.option);
               
                getProductLocations.getElements('POST', {}).then((response) => {
                    const data = JSON.parse(response);
                    if(!data.Error.CodigoStatusError) {
                        const productService = data.ServiciosAtencion ? data.ServiciosAtencion : data.RedAfiliadoServicios;
                        product.services = productService.map((service, index) => {
                            const name = this.capitalizeName(service.DescripcionUnidad);
                            return {
                                id: index+1,
                                loading: true,
                                code: product.request == 'ConsultarServiciosAtencion' ? service.Sede : service.CodigoSede,
                                name: name,
                                location: {}
                            };
                        });
                        product.loaded = true;
                        this.setState({ products });
                    } else {
                        this.setState({
                            currentAlert: (<Mensajes msg={this.props.configurations['MensajeErrorDeServicios']} />)
                        });
                    }
                });
            } 
            
        }
        this.setState({ productsActiveKey });
    }
  
    capitalizeName(description){
        let name = '';
        name = description.toLowerCase().split(' ')
            .map( (word) => {
              return (word.charAt(0).toUpperCase() + word.slice(1));
            });
        description = name.join(' ');
        return description;
      }
    
    loadSpecialityLocations(specialitiesActiveKey, productIndex) {
        if (specialitiesActiveKey) {
            const products = JSON.parse(JSON.stringify(this.state.products));
            const product = products[productIndex];
            const speciality = product.specialities[specialitiesActiveKey-1];
            
            if (speciality.loaded === false) {
                const getProductLocations = new ServicioProxy(product.request + '?tipoDocumento=' + (this.props.userInfo.TipoIdentificacion) + '&numeroDocumento=' + (this.props.userInfo.LegalID) + '&opcion=' + product.option + '&CodEspecialidad=' + speciality.option);
                
                getProductLocations.getElements('POST', {}).then((response) => {
                    const data = JSON.parse(response);
                    if (!data.Error.CodigoStatusError) {
                        const productService = data.ServiciosAtencion ? data.ServiciosAtencion : data.RedAfiliadoServicios;
                        speciality.services = productService.map((service, index) => {
                            const name = this.capitalizeName(service.DescripcionUnidad);
                            return {
                                id: index+1,
                                loading: true,
                                code: product.request == 'ConsultarServiciosAtencion' ? service.Sede : service.CodigoSede,
                                name: name,
                                location: {}
                            };
                        });
                        speciality.loaded = true;
                        this.setState({ products });
                    } else {
                        
                    this.setState({
                        currentAlert: (<Mensajes msg={this.props.configurations['MensajeErrorDeServicios']} />)
                    });
                   }
                });
            }
        }
        this.setState({ specialitiesActiveKey });
    }
    
    render() {
        return (
            <div>
                {/* Modal */}
                <div>{ this.state.currentAlert }</div>
                <PanelGroup accordion className="cs-accordeon" id={('products-accordeon-' + (this.props.beneficiaryIndex ? this.props.beneficiaryIndex : 'all') )} activeKey={this.state.productsActiveKey} onSelect={this.loadLocations}>
                { this.state.products.map((product, index) => {
                    if (product.id !== 5) {
                    return (<Panel eventKey={product.id} key={product.id} className={(product.type.indexOf(this.props.plan) == -1 ? 'hidden' : '')}>
                        <Panel.Heading>
                            <Panel.Title toggle>
                                <h5 className={( this.state.productsActiveKey-1 == index ? 'active-title' : 'inactive-title')}>{(product.name ? product.name : product['name' + this.props.plan])}</h5>
                                <div className={ 'accordion-icon ' + (this.state.productsActiveKey-1 == index ? 'active' : '' )}>
                                    <i className={ 'fa ' + ( this.state.productsActiveKey-1 == index ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i>
                                </div>
                                <p className="service-description">{ product.description }</p>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            { !product.specialities ? (
                                <ProductoSedes product={product} productIndex={index} updateProductsState={this.updateProductsState} />
                            ) : (
                                <PanelGroup accordion id={'specialities-accordeon-' + index} activeKey={this.state.specialitiesActiveKey} onSelect={(specialityActiveKey) => this.loadSpecialityLocations(specialityActiveKey, index)}>
                                    { product.specialities.map((speciality, specialityIndex) => {
                                        return (<Panel eventKey={speciality.id} key={speciality.id}>
                                            <Panel.Heading>
                                                <Panel.Title toggle>
                                                    <h5 className={( this.state.specialitiesActiveKey-1 == specialityIndex ? 'active-title' : 'inactive-title')}>{speciality.name}</h5>
                                                    <div className={ 'accordion-icon ' + (this.state.specialitiesActiveKey-1 == specialityIndex ? 'active' : '' )}>
                                                        <i className={ 'fa ' + ( this.state.specialitiesActiveKey-1 == specialityIndex ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down')}></i>
                                                    </div>
                                                </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Body collapsible>
                                                <ProductoSedes product={speciality} productIndex={index} specialityIndex={specialityIndex} updateProductsState={this.updateProductsState} />
                                            </Panel.Body>
                                        </Panel>);
                                    }) }
                                </PanelGroup>
                            ) }
                        </Panel.Body>
                    </Panel>);
                        
                    }
                }) }
                </PanelGroup>
            </div>
        );
    }
  }

/******************** BUILD ********************/
const PanelGroup = ReactBootstrap.PanelGroup;
const Panel = ReactBootstrap.Panel;
/******************** BUILD ********************/

export default Productos;



// WEBPACK FOOTER //
// ./salidaGraficaRed/miRedDeAtencion/otrosServiciosRedDeUrgencias/src/components/productos.js